/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Not_FoundInputs */

const cs_templates_not_found = /** @type {(inputs: Templates_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona nenalezena.`)
};

const en_templates_not_found = /** @type {(inputs: Templates_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template not found.`)
};

/**
* | output |
* | --- |
* | "Template not found." |
*
* @param {Templates_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_not_found = /** @type {((inputs?: Templates_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_not_found(inputs)
	return cs_templates_not_found(inputs)
});